export const TIME_SESSIONS = [
  { value: 'Morning', label: 'Morning (10:00 AM - 02:00 PM)', from: '10:00', to: '14:00' },
  { value: 'Afternoon', label: 'After Session (02:00 PM - 06:00 PM)', from: '14:00', to: '18:00' },
  { value: 'Evening', label: 'Evening (06:00 PM - 10:00 PM)', from: '18:00', to: '22:00' },
];

export const formatTime12h = (time24) => {
  if (!time24) return '';
  const [hStr, mStr = '00'] = String(time24).trim().split(':');
  let h = Number(hStr);
  if (!Number.isFinite(h)) return time24;
  const period = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${String(h).padStart(2, '0')}:${mStr.padStart(2, '0')} ${period}`;
};

export const PLAN_STATUSES = ['Pending', 'Approved', 'Rejected'];

export const getPlanStatusBadgeClass = (status) => {
  switch (status) {
    case 'Approved':
      return 'bg-emerald-50 text-emerald-700';
    case 'Rejected':
      return 'bg-rose-50 text-rose-700';
    default:
      return 'bg-amber-50 text-amber-800';
  }
};

export const formatSessionDisplay = (session, timeFrom, timeTo) => {
  const match = TIME_SESSIONS.find((s) => s.value === session);
  if (match) return match.label;
  if (timeFrom && timeTo) {
    return `${session} (${formatTime12h(timeFrom)} - ${formatTime12h(timeTo)})`;
  }
  return session || '—';
};
